import useCheckIfProductCanBePublished from './useCheckIfProductCanBePublished'

export default useCheckIfProductCanBePublished
